import { Injectable, Inject, RendererFactory2, Renderer2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoadingController, NavController } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
import { AlertController } from '@ionic/angular';
import { Router, NavigationExtras } from '@angular/router';
import { BaseService } from './base-service';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import * as Enums from './constants';
import { DOCUMENT } from '@angular/common';
import { MloggerProvider, Mlogger } from './mlogger.service';
import { Clipboard } from '@capacitor/clipboard';
import { timeout } from 'rxjs/operators';
import { of } from 'rxjs';
import { FileOpener } from '@ionic-native/file-opener/ngx';
@Injectable({
  providedIn: 'root'
})
export class CommonService extends BaseService {
  loading: any;
  renderer: Renderer2;
  deviceInfo: any;
  fileName: string = 'common.service.ts';
  constructor(
    private _mlogger: MloggerProvider,
    public _loading: LoadingController,
    private _httpClient: HttpClient,
    public _toast: ToastController,
    public _alert: AlertController,
    private navCtrl: NavController,
    private _fileOpener: FileOpener,
    private _router: Router, @Inject(DOCUMENT) private document, private renderFactory: RendererFactory2
  ) {
    super();
    this.renderer = this.renderFactory.createRenderer(null, null);
    this.changeTheme(this.getAppTheme());
  }

  changeTheme($event) {
    try {
      var element: any = document.getElementsByTagName('html')[0];
      this.renderer.setAttribute(element, "data-theme", this.getAppTheme());
      this.setAppTheme($event);
    }
    catch (error) {
      let obj = {
        fileName: this.fileName,
        functionName: 'changeTheme(themeName)',
        error: error
      }
      this.systemException(obj);
    }
  }
  changeTheme_DELETE(themeName) {
    this.removeTheme_DELETE(themeName);
    this.renderer.addClass(this.document.body, themeName);
  }

  removeTheme_DELETE(themeName) {
    if (localStorage.getItem("theme") === null) {
      localStorage.setItem("theme", themeName);
    } else {
      this.renderer.removeClass(this.document.body, localStorage.getItem("theme"));
      localStorage.setItem("theme", themeName)
    }
  }

  async showLoader() {
    this.loading = await this._loading.create({
      cssClass: 'my-custom-class',
      message: 'Loading...',
      backdropDismiss: true
    });
    await this.loading.present();
  }

  async hideLoader() {
    await this.loading.dismiss();
  }

  loadingShow() {
    // this.loading = await this._loading.create({
    //   cssClass: 'my-custom-class',
    // });
    // await this.loading.present();
    this._loading.create({
      message: 'Loading...'
    }).then((response) => {
      response.present();
    });
  }

  async loadingHide() {
    // await this._loading.dismiss();
    const ng = this;
    setTimeout(() => {
      ng._loading.dismiss();
    }, 2000);
  }
  loadingHide2() {
    this._loading.dismiss().then((response) => {
    }).catch((err) => {
      this.log('Error occured : ', err);
    });
  }

  async simpleToast(msg: string, tm = 5000) {
    const toast = await this._toast.create({
      message: msg,
      position: 'bottom',
      color: 'primary',
      translucent: false,
      animated: true,
      duration: tm
    });
    toast.present();
  }

  async notificationToast(msg: string, tm = 5000) {
    const toast = await this._toast.create({
      message: msg,
      position: 'top',
      color: 'primary',
      translucent: false,
      animated: true,
      duration: tm
    });
    toast.present();
  }

  async errorToast(msg: string, tm = 3000) {
    const toast = await this._toast.create({
      message: msg,
      position: 'top',
      color: 'danger',
      translucent: false,
      animated: true,
      duration: 5000
    });
    toast.present();
  }

  async simpleAlert(headerVal: string, messageVal: string) {
    const alert = await this._alert.create({
      cssClass: 'my-custom-class',
      mode: 'ios',
      header: headerVal,
      message: messageVal,
      buttons: ['OK']
    });
    await alert.present();
  }

  routeToPage(page, data) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        data: JSON.stringify(data)
      }
    };
    this._router.navigate(['./' + page], navigationExtras);
  }
  getParamData() {
    const data = JSON.parse(this._router.getCurrentNavigation().extras.queryParams.data);
    //this.log({ paramData: data });
    return typeof data !== 'undefined' ? data : null;
  }

  public convertBlobToBase64 = (blob) => new Promise((resolve, reject) => {
    this.log('-- convertBlobToBase64 --');
    // tslint:disable-next-line:new-parens
    const fileReader = new FileReader();
    const zoneOriginalInstance = (fileReader as any).__zone_symbol__originalInstance;
    const reader = zoneOriginalInstance || fileReader;
    reader.onerror = () => {
      this.log({
        failure: 'error'
      });
      reject({ error: 'error in convertBlobToBase64' });
    };
    reader.onload = () => {
      this.log({
        success: reader.result
      })
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });

  getLocalData(obj): any {
    let columnArray = Enums.COLUMNS;
    return this._httpClient.get<any>('./assets/data-models/' + obj.local_json_file + '.json', {}).pipe(map(resp => {
      if (resp.status) {
        if (obj.mapcol) {
          resp.columns.forEach((item, index) => {
            resp.columns[index] = columnArray[item];
          });
        }
        return resp;
      }
    }));
  }

  fetchData(dataObj): any {
    var element: any = document.getElementsByTagName("ion-loading")[0];
        
    this.systemException({
      fileName: 'API call ',
      functionName: dataObj.api_url,
      error: dataObj
    });
    let columnArray = Enums.COLUMNS;
    if (!this.isOnLine()) {
      this.simpleToast(Enums.CONSTANTS.OFFLINE_MSG);
      if(element != undefined)
        element.style.display='none';
      return { error: '', d_type: 'local', status: false, count: 0, data: [], message: "You are offline" };
      //return this.getLocalData(dataObj);
    } else {
      let row_offset = dataObj.offset;
      let data = dataObj.param_data;
      let url = dataObj.api_url;
      if (dataObj?.param_data?.file) {
        data = dataObj.param_data?.file;
      }
      if (dataObj.method === 'post') {
        return this._httpClient.post<any>(url, data).pipe(
          timeout(Enums.CONSTANTS.API_TIMEOUT),
          catchError(e => {
            let obj = {
              fileName: this.fileName,
              functionName: 'fetchData()',
              error: e
            }
            this.systemException(obj);
            if(element != undefined)
              element.style.display='none';
            if (e.status == '403') {
              this.errorToast(Enums.CONSTANTS.SESSION_ALERT_MSG);
              this.navCtrl.navigateRoot(['./']);
            }
            return of({ error: e, d_type: 'local', status: false, count: 0, data: [], message: Enums.CONSTANTS.API_TIMEOUT_MSG });
          })
        ).pipe(map(resp => {

          if (resp?.status) {
            if (dataObj.mapcol) {
              resp?.columns.forEach((item, index) => {
                resp.columns[index] = columnArray[item];
              });
            }
            return resp;
          } else {
            return resp;
          }
          /*
          if (resp?.status && (resp?.data == null || resp?.data?.length > 0)) {
            if (dataObj.mapcol) {
              resp?.columns.forEach((item, index) => {
                resp.columns[index] = columnArray[item];
              });
            }
            return resp;
          }
          if ((resp?.data == null || resp.data?.length == 0) || !resp?.status) {
            return { d_type: 'local', message: resp.message, status: true, count: 0, data: [] };
          }*/
        }, (error) => {
          return { error: error, d_type: 'local', status: true, count: 0, data: [] };
        }));
      }
      if (dataObj.method === 'get') {
        return this._httpClient.get<any>(url).pipe(
          timeout(Enums.CONSTANTS.API_TIMEOUT),
          catchError(e => {
            let obj = {
              fileName: this.fileName,
              functionName: 'fetchData()',
              error: e
            }
            this.systemException(obj);
            if (e.status == '403') {
              this.errorToast(Enums.CONSTANTS.SESSION_ALERT_MSG);
              this.navCtrl.navigateRoot(['./']);
            }
            return of({ error: e, d_type: 'local', status: false, count: 0, data: [], message: Enums.CONSTANTS.API_TIMEOUT_MSG });

          })
        ).pipe(map(resp => {
          if (resp?.status) {
            if (!dataObj.mapcol)
              return resp;
          } else {
            if (resp.data?.length == 0 || !resp?.status) {
              return this.getLocalData(dataObj);
            }
          }
        }));
      }

      if (dataObj.method === 'patch') {
        return this._httpClient.patch<any>(url, dataObj?.body).pipe(
          timeout(Enums.CONSTANTS.API_TIMEOUT),
          catchError(e => {
            let obj = {
              fileName: this.fileName,
              functionName: 'fetchData()',
              error: e
            }
            this.systemException(obj);
            if (e.status == '403') {
              this.errorToast(Enums.CONSTANTS.SESSION_ALERT_MSG);
              this.navCtrl.navigateRoot(['./']);
            }
            return of({ error: e, d_type: 'local', status: false, count: 0, data: [], message: Enums.CONSTANTS.API_TIMEOUT_MSG });
          })
        ).pipe(map(resp => {
          if (resp?.status) {
            if (!dataObj.mapcol)
              return resp;
          } else {
            if (resp.data?.length == 0 || !resp?.status) {
              return this.getLocalData(dataObj);
            }
          }
        }));
      }
    }
  }

  systemException(obj: any) {
    this.logger(Mlogger.severity.debug, [], Mlogger.step.log, obj.fileName + ' in ' + obj.functionName, obj.error);
    // this.log({
    //   systemException: obj
    // });
  }
  /**create a param object for sentry data input */
  logger(severity, obj, step, fn_name, fn_param) {
    this.log(fn_name);
    if (1) {
      let array;
      let operation;
      let data;
      switch (step) {
        case Mlogger.step.start:
          array = step;
          operation = 'Start: ';
          data = {
            fn_start_time: performance.now(),
          }
          break;
        case Mlogger.step.log:
          operation = 'Log: ';
          let paramObj = {
            data: fn_param,
            message: operation + fn_name,
            timestamp: Math.floor(Date.now() / 1000)
          }
          this._mlogger.log(severity, step, null, this.getLocalUserId(), null, null, operation + fn_name, null, paramObj);
          return;
        case Mlogger.step.end:
          array = 1;
          operation = 'End: ';
          data = {
            fn_end_time: performance.now(),
          }
          break;
      }
      data.fn_param = fn_param;
      data.fn_name = fn_name;
      obj[array] = {
        data: data,
        message: operation + fn_name,
        timestamp: Math.floor(Date.now() / 1000)
      }
      this._mlogger.log(0, step, null, this.getLocalUserId(), null, null, operation + fn_name, null, obj);
    }
  }

  async copyText(text) {
    try {
      await Clipboard.write({
        string: text
      });
      this.simpleToast("Copied", 500);
    }
    catch (error) {
      let obj = {
        fileName: this.fileName,
        functionName: 'copyText(text)',
        error: error
      }
      this.systemException(obj);
    }
  }

  async copyInfo(text) {
    try {
      await Clipboard.write({
        string: text
      });
      this.simpleToast("Information Copied", 500);
    }
    catch (error) {
      let obj = {
        fileName: this.fileName,
        functionName: 'copyInfo(text)',
        error: error
      }
      this.systemException(obj);
    }
  }

  openFile(obj) {
    try {
      var mimeType = obj.base64.split(';')[0].split(':')[1];
      this._fileOpener.open(obj.filePath, mimeType)
        .then(() => { this.simpleToast('File downloaded') })
        .catch((err) => { this.simpleToast('Error in opening the file / not supported in browser'); this.log(err) });
    }
    catch (error) {
      let obj = {
        fileName: this.fileName,
        functionName: 'openFile(filePath)',
        error: error
      }
      this.systemException(obj);
    }
  }

  fileValidation(fileSizeInBytes) {
    const fileSizeInMB: any = (fileSizeInBytes / (1024 * 1024)).toFixed(2);
    if (fileSizeInMB < Enums.CONSTANTS.FILESIZE_LIMIT_IN_MB) {
      return true;
    }
    else {
      this.simpleAlert("Failed", Enums.CONSTANTS.INVALID_FILESIZE_ALERT_MSG);
      return false;
    }
  }
}
